import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// HTTPステータスコード定数
const HTTP_STATUS = {
  UNAUTHORIZED: 401,
} as const;

// タイムアウト定数（ミリ秒）- Nginxのproxy_read_timeoutと同期
const REQUEST_TIMEOUT_MS = 120000;

// Axiosインスタンスの作成
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: REQUEST_TIMEOUT_MS,
  withCredentials: true, // ✅ 重要: Cookieを送受信するために必須
});

// リクエストインターセプター：Cookieが自動的に送信されるため不要
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Cookieが自動的に送信されるため、手動でのトークン付与は不要
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター：エラーハンドリング
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
      const requestUrl = error.config?.url || '';

      // 2FAフロー中のエンドポイントは401でもリダイレクトしない
      // - /api/auth/session: 認証チェック用なので正常な動作
      // - /api/auth/verify-2fa: 2FAコード検証中（pendingToken期限切れの可能性）
      // - /api/auth/resend-2fa: 2FAコード再送信中（pendingToken期限切れの可能性）
      const shouldSkipRedirect =
        requestUrl.includes('/api/auth/session') ||
        requestUrl.includes('/api/auth/verify-2fa') ||
        requestUrl.includes('/api/auth/resend-2fa');

      if (!shouldSkipRedirect) {
        // 認証エラーの場合、ログイン画面へ
        // Cookieはサーバー側で削除される

        // 既にログインページにいる場合はリダイレクトしない
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);